import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import {
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core/styles';
import clsx from 'clsx';

import logo from '../../assets/img/ph/logo-blue.svg';
import { useTitle } from '../../hooks';
import { Link, Button, HelpDocLink } from '../../components';
import lightHouseArticles from '../../configs/lightHouseArticles';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentUser } from '../../store/modules/users/selectors';
import { checkCheckoutProductsRequest } from '../../store/modules/billing/actions';

const useStyles = makeStyles(({ palette, colors, breakpoints }: Theme) => createStyles({
  root: {
    background: colors.backgroundColor,
    position: 'absolute',
    left: 0,
    right: 0,
    height: '100%',
    [breakpoints.down('xs')]: {
      background: '#FFF',
      position: 'unset',
    },
  },
  wrapper: {
    margin: '25px 0 0 0',
    background: '#FFF',
    maxWidth: '620px',
    maxHeight: '600px',
    textAlign: 'center',
  },
  logo: {
    height: '64px',
    width: '64px',
    margin: '60px 0 20px 0',
  },
  button: {
    margin: '50px 0 60px 0',
    maxWidth: '190px',
    width: '100%',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    fontSize: '16px',
    fontFamily: 'Montserrat, sans',
    boxShadow: 'none',
    letterSpacing: '0.21px',
  },
  buttonSingle: {
    color: '#FFF',
    background: palette.buttonSingle.color,
    '&:hover': {
      backgroundColor: palette.buttonSingle.color,
    },
  },
  buttonLink: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  text: {
    fontFamily: 'Montserrat',
    fontSize: '24px',
    color: '#26325F',
    fontWeight: 500,
  },
  textSmall: {
    fontFamily: 'Montserrat',
    fontSize: '16px',
    color: '#26325F',
    fontWeight: 500,
  },
  title: {
    fontSize: '32px',
    fontWeight: 'bold',
  },
  content: {
    maxWidth: '410px',
    margin: 'auto',
  },
  link: {
    color: 'inherit',
    '&:hover': {
      textDecoration: 'none',
    },
  },
}), { name: 'Dashboard' });

const Dashboard = () => {
  useTitle('Dashboard');
  const classes = useStyles();

  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);

  useEffect(() => {
    if (user.data?.ref.require_checkout) {
      dispatch(checkCheckoutProductsRequest(user.data.id));
    }
  }, [user, dispatch]);

  return (
    <Grid container justify="center" className={classes.root}>
      <Grid item xs={12} className={classes.wrapper}>
        <img src={logo} alt="Logo" className={classes.logo} />
        <div className={classes.content}>
          <h1 className={clsx(classes.text, classes.title)}>Welcome to PitchHub!</h1>
          <p className={classes.text}>Let's get started making videos in ClipPress!</p>
        </div>
        <Link to="/dashboard/projects" className={classes.buttonLink}>
          <Button
            variant="contained"
            className={clsx(classes.button, classes.buttonSingle)}
            data-intercom-target="ClipPress button"
          >
            ClipPress
          </Button>
        </Link>
        <div className={classes.content}>
          <p className={classes.textSmall}>
            First time user? Please see this&nbsp;
            <HelpDocLink id={lightHouseArticles.helpPage}>
              help page
            </HelpDocLink>
          </p>
        </div>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
